import React, { useEffect, useRef } from "react";
import { useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { useHistory, useParams, Link } from "react-router-dom";
import SVG from "react-inlinesvg";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
  toAbsoluteUrl,
} from "../../../../../../_metronic/_helpers";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  ConvertToDateCurrentTimeZoneOnlyDate,
  Currency,
  ExportAs,
  getFromatdate,
} from "../../../../../../_metronic/_helpers/GlobalHelpers";
import "react-google-flight-datepicker/dist/main.css";
import { RangeDatePicker } from "react-google-flight-datepicker";
import moment from "moment";
import {
  ModelStateMessage,
  apiCalll,
} from "../../../../../../_metronic/_helpers/apiHelpers";
import Swal from "sweetalert2";
import { useReactToPrint } from "react-to-print";
import ReactSelect from "react-select";
import Bill from "./Bill";
import BillShort from "./BillShort";
import html2pdf from 'html2pdf.js';
import SelectAsyncPaginateDrivers from "../../manageorders/orders-fetch-dialog/SelectAsyncPaginateDrivers";
import UploadFiles from "../../manageorders/pharmacy-details/UploadFiles";
import FileViewerModal from "../../approvedrivers/FileViewerModal";


const DriverBillsTable = (props) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const token = JSON.parse(localStorage.getItem("user")).token;
  const [pagination, setPagination] = useState([]);
  const [orders, setOrders] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [show, setShow] = useState(false);
  const [invoicesShort, setInvoicesShort] = useState([]);
  const [showShort, setShowShort] = useState(false);
  const params = useParams();
  const id = params.id;
  const [driverId, setDriverId] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [downloadIsLoading, setDownloadIsLoading] = useState(false);
  const [chargeSuccess, setChargeSuccess] = useState(null);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [invoiceId, setInvoiceId] = useState(null);
  const [isSending, setIsSending] = useState(false);
  const [fastPayout, setFastPayout] = useState("");
  const [isLaoding, setIsLaoding] = useState(false);
  const [showUpload, setShowUpload] = useState(false);
  const [showFile, setShowFile] = useState(false);
  const [path, setPath] = useState(false);
  const history = useHistory();
  const componentRef = useRef();
  const [initFilter, setinitFilter] = useState({
    page: 1,
    sizePerPage: localStorage.getItem("billsPageSize")
      ? parseInt(localStorage.getItem("billsPageSize"))
      : 10,
    sortField: "Id",
    sortOrder: "desc",
    custom: true,
    totalSize: 100,
    sizePerPageList: [
      { text: "10", value: 10 },
      { text: "20", value: 20 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
    ],
  });


  
  const fetchBlobContent = (id) => {
    fetch(`${BASE_URL}/Invoicing/GetBillPdfLink/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      Allow: "GET",
    })
      .then(async (response) => {
        const statusCode = await response.status;
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((data) => [statusCode, data]);
        } else {
          return response.text().then((data) => [statusCode, data]);
        }
      })
      .then((data) => {
        if (data[0] === 200) {
           setPath(data[1]?.fileUrl);
           setShowFile(true)
        }
        else if (data[0] === 401) {
          history.push("/logout");
        }
      })
      .catch((error) => {
        console.log(error);
      })
  };

  const handleRetryQuickBooks = (id) => {
    setIsLaoding(true);
    fetch(`${BASE_URL}/Payouts/InsertBillQuickbook?id=${id}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      },
      Allow: "POST",
    })
      .then(async (response) => {
        const statusCode = await response.status;
        const contentType = response.headers.get("content-type");
        if (
          contentType && contentType.indexOf("application/json") !== -1
        ) {
          return response.json().then((data) => [statusCode, data]);
        } else {
          return response.text().then((data) => [statusCode, data]);
        }
      })
      .then(data => {
        if (data[0] === 200) {
          handleGetOrders(initFilter);
          Swal.fire({
            title: "Success!",
            text: "Bill has been sent to QuickBooks successfully!",
            icon: "success",
            confirmButtonText: "Ok",
          });
        }
        else if (data[0] === 401) {
          history.push("/logout");
        }
        else if (data[0] === 400 && data[1].message) {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: data[1].message,
          })
        }
        else if (data[0] === 400) {
          let tt = JSON.parse(data[1]);
          for (const [key, value] of Object.entries(tt.errors)) {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: value,
            })
          }
        }
        else if (data[0] === 500) {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Something went wrong, please try again later!',
          })
        }
      })
      .catch((error) => {
        console.log(error);
      }).finally(() => {
        setIsLaoding(false);
      })
  }

  useEffect(() => {
    if(isLaoding){
      Swal.fire({
        title: "Processing!",
        html: "Please wait while we are processing your request.",
        timer: 9000,
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading();
        },
      }).then((result) => {
        /* Read more about handling dismissals below */
        if (result.dismiss === Swal.DismissReason.timer) {
          console.log("I was closed by the timer");
        }
      });
    }

  }, [isLaoding]);

  function Export(Type, id) {
    apiCalll({
      method: "GET",
      link: `/Payouts/GetTotalChargeBillId?billId=${id}&timezone=${getTimeZoneOffset()}`,
    })
      .then(async (result) => {
        if (result[0] === 200) {
          var listOrders = [];
          var data = result[1]?.ordersViewModel;
          data.map((k) => {
            var a = JSON.stringify(k);
            a = a.replaceAll('"code":', '"Code":');
            a = a.replaceAll('"billNumber":', '"Bill Number":');
            a = a.replaceAll('"deliveryLocation":', '"Delivery Location":');
            a = a.replaceAll('"pickupLocation":', '"Pickup Location":');
            a = a.replaceAll('"actualPickupDate":', '"Actual Pickup Date":');
            a = a.replaceAll('"actualDeliveryDate":', '"Actual Delivery Date":');
            a = a.replaceAll('"distance":', '"Distance":');
            a = a.replaceAll('"driver":', '"Driver":');
            a = a.replaceAll('"bonus":', '"Bonus":');
            a = a.replaceAll('"bonusDescription":', '"Bonus Description":');
            a = a.replaceAll('"additionalCharges":', '"Additional Charges":');
            a = a.replaceAll('"charge":', '"Charge":');
            a = a.replaceAll('"tips":', '"Tips":');
            a = a.replaceAll('"subTotal":', '"SubTotal":');
            a = a.replaceAll('"total":', '"Total":');
            a = JSON.parse(a);
            listOrders.push(a)
          })
          const entity = "Bill" + "_" + (data[0]?.billNumber || "");
          ExportAs(listOrders || [], Type, entity);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  }
  const handleGetTotalInvoiceByDate = (billId, driverId) => {
    setIsLoading(true);
    fetch(
      `${BASE_URL}/Payouts/GetBillBreakdown?BillId=${billId}&driverId=${id || driverId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        Allow: "GET",
      }
    )
      .then(async (response) => {
        const statusCode = await response.status;
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((data) => [statusCode, data]);
        } else {
          return response.text().then((data) => [statusCode, data]);
        }
      })
      .then((data) => {
        if (data[0] === 200) {
          setInvoices(data[1]);
          setShow(true);
        }
        else if (data[0] === 401) {
          history.push("/logout");
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  const handleGetBillBreakdownShort = (billId, driverId) => {
    setIsLoading(true);
    fetch(
      `${BASE_URL}/Payouts/GetBillBreakdownShort?BillId=${billId}&driverId=${id || driverId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        Allow: "GET",
      }
    )
      .then(async (response) => {
        const statusCode = await response.status;
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((data) => [statusCode, data]);
        } else {
          return response.text().then((data) => [statusCode, data]);
        }
      })
      .then((data) => {
        if (data[0] === 200) {
          setInvoicesShort(data[1]);
          setShowShort(true);
        }
        else if (data[0] === 401) {
          history.push("/logout");
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const columns = [
    {
      dataField: "billNumber",
      text: "Bill #",
      sort: true,
      sortCaret: sortCaret,
      formatter: (cellContent, row) => <b>#{row?.billNumber}</b>,
      headerSortingClasses,
    },
    props?.isBills === true &&    
    {
      dataField: "firstName",
      text: "Driver name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (cellContent, row) => (
      <Link
        className="text-info font-weight-bolder text-hover-muted mb-1 font-size-lg"
        to={`/driver/${row.driverId}/details/payout`}
      >
           {row?.firstName} {row?.lastName}
      </Link>
    ),
    },
    props?.isBills === true &&  {
      dataField: "email",
      text: "Email",
      sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
    },
    {
      dataField: "created",
      text: "Created Date",
      headerFormatter: (cellContent, row) => (
        <>
          Created Date
          <OverlayTrigger
            key={"right"}
            placement={"right"}
            overlay={
              <Tooltip id={`tooltip-${"placement"}`}>{getFromatdate()}</Tooltip>
            }
          >
            <span
              style={{ cursor: "pointer" }}
              className="svg-icon menu-icon svg-icon-info"
            >
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Code/Info-circle.svg")}
              />
            </span>
          </OverlayTrigger>
        </>
      ),
      sort: true,
      sortCaret: sortCaret,
      formatter: (cellContent, row) => (
        // format date to dd/mm/yyyy
        <p>
          {!!row.created
            ? ConvertToDateCurrentTimeZoneOnlyDate(row.created)
            : "-"}
        </p>
      ),
      headerSortingClasses,
    },
    {
      dataField: "paidDate",
      text: "Paid Date",
      headerFormatter: (cellContent, row) => (
        <>
          Paid Date
          <OverlayTrigger
            key={"right"}
            placement={"right"}
            overlay={
              <Tooltip id={`tooltip-${"placement"}`}>{getFromatdate()}</Tooltip>
            }
          >
            <span
              style={{ cursor: "pointer" }}
              className="svg-icon menu-icon svg-icon-info"
            >
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Code/Info-circle.svg")}
              />
            </span>
          </OverlayTrigger>
        </>
      ),
      sort: true,
      sortCaret: sortCaret,
      formatter: (cellContent, row) => (
        // format date to dd/mm/yyyy
        <p>
          {!!row?.paidDate
            ? ConvertToDateCurrentTimeZoneOnlyDate(row?.paidDate)
            : "-"}
        </p>
      ),
      headerSortingClasses,
    },
    {
      dataField: "startDate",
      text: "Pay Period ",
      sort: true,
      sortCaret: sortCaret,
      formatter: (cellContent, row) => (
        <>
          {row.startDate && ConvertToDateCurrentTimeZoneOnlyDate(row.startDate)}
          {" - "}
          {row.endDate && ConvertToDateCurrentTimeZoneOnlyDate(row.endDate)}
        </>
      ),
      headerSortingClasses,
    },
    {
      dataField: "byDriver",
      text: "Fast Payout",
      sort: true,
      sortCaret: sortCaret,
      formatter: (cellContent, row) => (
        <>
          {row.byDriver && (
            <span className="svg-icon svg-icon-3x svg-icon-primary ml-5">
            <SVG src={toAbsoluteUrl("/media/icons/speedy.svg")}/>
          </span>
          )}
        </>
      ),
      headerSortingClasses,
    },
    {
      dataField: "paymentSuccess",
      text: "Status",
      sort: true,
      sortCaret: sortCaret,
      formatter: (cellContent, row) => (
        <span
          onClick={() => {
            if (!row.paymentSuccess) {
              Swal.fire({
                title: "Are you sure?",
                text: "You want to mark this bill as paid!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, mark it!",
                cancelButtonText: "No, cancel!",
                reverseButtons: true,
              }).then((result) => {
                if (result.isConfirmed) {
                  PayInvoice(row?.id);
                }
              });
            }
          }}
          className={`label label-lg text-white label-inline font-weight-bold py-4 cursor-pointer bg-${
            row?.paymentSuccess ? "success" : "danger"
          }`}
          style={{
            whiteSpace: "nowrap",
          }}
        >
          {row.paymentSuccess ? "Paid" : "Unpaid"}
        </span>
      ),
      headerSortingClasses,
    },
    {
      dataField: "paymentType",
      text: "Payment Method",
      sort: true,
      sortCaret: sortCaret,
      formatter: (cellContent, row) => (
        <span
          className={`label label-lg text-white label-inline font-weight-bold py-4 cursor-pointer`}
          style={{
            whiteSpace: "nowrap",
            backgroundColor:
              row?.paymentType === "Stripe" ? "#635bff" : "#ffb92a",
          }}
        >
          {row?.paymentType === "Stripe" ? "Stripe" : "EMT"}
        </span>
      ),
      headerSortingClasses,
    },
    {
      dataField: "pdf",
      text: "Bill",
      sort: false,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (cellContent, row) => (
        <button
          onClick={() => {
            handleGetTotalInvoiceByDate(row?.id, row?.driverId);
            setInvoiceId(row?.id);
            setDriverId(row?.driverId);
          }}
          className={`btn btn-secondary font-weight-bolder font-size-sm`}
        >
          Bill
        </button>
      ),
    },
    {
      dataField: "summary",
      text: "Summary",
      sort: false,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (cellContent, row) => (
        <div className="d-flex align-items-center">
        <button
          onClick={() => {
            if(row?.attachedPdfPath){
              fetchBlobContent(row?.id)
            }else{
              handleGetBillBreakdownShort(row?.id, row?.driverId);
              setInvoiceId(row?.id);
              setDriverId(row?.driverId);
            }
          }}
          className={`btn btn-secondary font-weight-bolder font-size-sm`}
        >
          Summary
        </button>
        {row.manualEmt && <OverlayTrigger
            key={"right"}
            placement={"right"}
            overlay={
              <Tooltip id={`tooltip-${"placement"}`}>
                Payment Manually
              </Tooltip>
            }
          >
        <span
            style={{ cursor: "pointer" }}
            className="svg-icon menu-icon svg-icon-info ml-2"
            >
              <SVG
                src={toAbsoluteUrl("/media/icons/manual.svg")}
              />
          </span>
        </OverlayTrigger>}
        </div>
      ),
    },
    {
      dataField: "quickbookSuccess",
      text: "QuickBooks",
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (cellContent, row) => (
        <>
          {row.quickbookSuccess === false &&  
          <OverlayTrigger
            key={"right"}
            placement={"right"}
            overlay={
              <Tooltip id={`tooltip-${"placement"}`}>
                {row?.quickbooksError} {row?.quickbooksError && "- (Click to retry)"}
                </Tooltip> }
          >
            <span 
              onClick={() => {
                Swal.fire({
                  title: "Are you sure?",
                  text: "You want to retry sending this invoice to QuickBooks!",
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#1BC5BD",
                  cancelButtonColor: "#0058B1",
                  confirmButtonText: "Yes, I do!",
                }).then((result) => {
                  if (result.isConfirmed) {
                    handleRetryQuickBooks(row?.id);
                  }
                });
              }}
            className="svg-icon menu-icon svg-icon-info svg-icon-2x cursor-pointer">
              <SVG
                src={toAbsoluteUrl("/media/icons/quickbooks.svg")}
              />
            </span>
          </OverlayTrigger>}

          {row?.quickbookSuccess === true && <span className="svg-icon menu-icon svg-icon-info svg-icon-2x cursor-pointer">
              <SVG
                src={toAbsoluteUrl("/media/icons/quickbooksgreen.svg")}
              />
          </span>}

          {row?.quickbookSuccess === null && <span className="svg-icon menu-icon svg-icon-info svg-icon-2x cursor-pointer">
              <SVG
                src={toAbsoluteUrl("/media/icons/quickbooksgrey.svg")}
              />
          </span>}
        </>
      ),
    },
    {
      dataField: "id",
      text: "Export",
      sort: false,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (cellContent, row) => (
        <button
          onClick={() => {
            Export("excel", row?.id);
          }}
          className="btn btn-success font-weight-bolder font-size-sm"
        >
          Excel
        </button>
      ),
    },
    {
      dataField: "hsttax",
      text: "HST",
      sort: true,
      sortCaret: sortCaret,
      formatter: (cellContent, row) => (
        <>{row?.hsttax ? Currency(row?.hsttax || 0) : "$0.00"}</>
      ),
      headerSortingClasses,
    },
    {
      dataField: "totalWithTax",
      text: "Paid Amount",
      sort: true,
      sortCaret: sortCaret,
      formatter: (cellContent, row) => (
        <>{row?.totalWithTax ? Currency(row?.totalWithTax || 0) : "$0.00"}</>
      ),
      headerSortingClasses,
    },
   {          
      dataField: "stripeView",
      text: "Custom Bill",
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (cellContent, row) => (
        <span 
        className={`svg-icon menu-icon svg-icon-${row?.attachedPdfPath ? "success": "secondary"} svg-icon-2x cursor-pointer ml-5`}
        onClick={() => {
          setInvoiceId(row?.id)
          setShowUpload(true)
        }}
        >
        <SVG
          src={toAbsoluteUrl("/media/svg/icons/Files/Export.svg")}
        />
      </span>
      ),
    },
  ];

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const GetHandlerTableChange = (type, newState) => {
    let values = { ...initFilter };
    if (type === "sort") {
      values.sortField = newState.sortField;
      values.sortOrder = newState.sortOrder;
    }
    if (type === "pagination") {
      values.sizePerPage = newState.sizePerPage;
      values.page = newState.page === undefined ? 1 : newState.page;
    }
    setinitFilter(values);
  };

  const firstLetterUppercase = (word) => {
    return word.charAt(0).toUpperCase() + word.slice(1);
  };

  function getTimeZoneOffset() {
    const offsetInMinutes = new Date().getTimezoneOffset();

    const hours = Math.floor(Math.abs(offsetInMinutes) / 60);
    const sign = offsetInMinutes < 0 ? "+" : "-";

    return `${sign}${hours.toString().padStart(2, "")}`;
  }

  const handleGetOrders = (filter) => {
    filter.pageSize = localStorage.getItem("billsPageSize")
      ? parseInt(localStorage.getItem("billsPageSize"))
      : 10;
    fetch(
      `${BASE_URL}/${props?.isBills ? `Invoicing/GetBills?driverId=${selectedDriver?.value || ""}&` :`Payouts/GetBills?driverId=${id}&`}ChargeSuccess=${chargeSuccess ||
        ""}&FastPayout=${fastPayout ||
        ""}&pageNumber=${filter?.page}&pageSize=${
        filter?.sizePerPage
      }&&sortOrder=${filter?.sortOrder}&sortField=${firstLetterUppercase(
        filter?.sortField
      )}&startDate=${startDate || ""}&endDate=${endDate ||
        ""}&search=${encodeURIComponent(search) || ""}&timezone=${getTimeZoneOffset()}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        Allow: "GET",
      }
    )
      .then(async (response) => {
        const statusCode = await response.status;
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((data) => [statusCode, data]);
        } else {
          return response.text().then((data) => [statusCode, data]);
        }
      })
      .then((data) => {
        if (data[0] === 200) {
          setOrders(data[1]);
          setPagination(data[1]?.pagination);
        }
        else if (data[0] === 401) {
          history.push("/logout");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  function PayInvoice(BillId) {
    return apiCalll({
      method: "GET",
      link: `/Payouts/SetBillsAsPaid?billId=${BillId}`,
    })
      .then((res) => {
        if (res[0] === 200) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Bill marked as paid successfully!",
          });
          handleGetOrders(initFilter);
          !props?.isBills && props.handleGetDriverDetails(id);
        } else if (res[0] === 402) {
          Swal.fire({
            title: "Info!",
            text: "You have to subscribe first",
            icon: "info",
            confirmButtonText: "Ok",
          }).then((result) => {
            if (result.isConfirmed) {
              history.push("/user-profile");
            }
          });
        } else {
          ModelStateMessage(res);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  useEffect(() => {
    const debounceSearch = setTimeout(() => {
      handleGetOrders(initFilter);
    }, 500);
    return () => {
      clearTimeout(debounceSearch);
    };
  }, [initFilter, search, startDate, endDate, chargeSuccess, fastPayout,selectedDriver]);

  const paginationOptions = {
    custom: true,
    totalSize: pagination?.totalItemCount || 0,
    sizePerPageList: initFilter?.sizePerPageList || [],
    sizePerPage: pagination?.pageSize || 10,
    page: pagination?.pageNumber || 1,
  };

  const status = [
    {
      label: "All",
      value: "",
    },
    {
      label: "Paid",
      value: "true",
    },
    {
      label: "Unpaid",
      value: "false",
    },
  ];

  const payouts = [
    {
      label: "All",
      value: "",
    },
    {
      label: "Fast Payout",
      value: "true",
    },
    {
      label: "Regular Payout",
      value: "false",
    },
  ];

  const downloadBillAsPDF = async () => {
    const element = componentRef.current;

    const timestamp = new Date().getTime();
    const invoice = show ? invoices : invoicesShort;
    const filename = invoice?.billNumber
        ? `Bill-${invoice.billNumber}.pdf`
        : `Bill-${timestamp}.pdf`;

    const options = {
        margin: 0,
        filename,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 1, logging: false },
        jsPDF: {
            unit: 'in',
            format: 'a3',
            orientation: 'portrait',
        },
    };

    try {
        await html2pdf().set(options).from(element).save();
    } finally {
        setDownloadIsLoading(false);
    }
};

function SendBillByEmail() {
  setIsSending(true);
  apiCalll({
    method: "GET",
    link: `/Invoicing/SendEmailBill?BillId=${invoiceId}&driverId=${id || driverId}`,
  })
    .then(async (data) => {
      if (data[0] === 200) {
        Swal.fire({
          title: "Success!",
          text: "Bill sent successfully!",
          icon: "success",
          confirmButtonText: "Ok",
        });
      }else if (data[0] === 400 && data[1].message) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: data[1].message,
        });
      } else if (data[0] === 400) {
        let tt = JSON.parse(data[1]);
        for (const [key, value] of Object.entries(tt.errors)) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: value,
          });
        }
      } else if (data[0] === 401) {
        history.push("/logout");
      } else if (data[0] === 402) {
        Swal.fire({
          title: "Info!",
          text: "You have to subscribe first!",
          icon: "info",
          confirmButtonText: "Ok",
        }).then((result) => {
          if (result.isConfirmed) {
            history.push("/user-profile");
          }
        });
      }
    })
    .catch((error) => {
      console.log("error", error);
    }).finally(() => {
      setIsSending(false);
    }
    );
}
  return (
    <>
     <button
        type="button"
        hidden
        id="refreshMasterInvoice"
        className="btn btn-success mt-4"
        onClick={() => {
          handleGetOrders(initFilter);
        }}
          >
           Refresh 
      </button>
      <div className="row mb-7">
        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
          <input
            type="text"
            className="form-control"
            name="search"
            placeholder="Search"
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />
          <small className="form-text text-muted">
            <b>Search</b> in all fields
          </small>
        </div>
        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
          <RangeDatePicker
            startDate={
              startDate !== null && moment(startDate).format("YYYY-MM-DD")
            }
            endDate={endDate !== null && moment(endDate).format("YYYY-MM-DD")}
            onChange={(startDate, endDate) => {
              startDate === null
                ? setStartDate(null)
                : setStartDate(moment(startDate).format("YYYY-MM-DD"));

              endDate === null
                ? setEndDate(null)
                : setEndDate(moment(endDate).format("YYYY-MM-DD"));
            }}
            dateFormat="MM/DD/YYYY"
            minDate={new Date(1900, 0, 1)}
            maxDate={new Date(2100, 0, 1)}
            startDatePlaceholder="Start Date"
            endDatePlaceholder="End Date"
            disabled={false}
            startWeekDay="monday"
          />
          <small className="form-text text-muted">
            <b>Filter</b> by Date
          </small>
        </div>
       {props?.isBills &&
        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
          <SelectAsyncPaginateDrivers
              apiLink={`${BASE_URL}/drivers/dropdown`}
              value={selectedDriver}
              isDisabled={false}
              isClearable={true}
              placeholder='All'
              width='100%'
              onChange={async (e) => {
                if(e){
                  setSelectedDriver(e);
                }else{
                  setSelectedDriver(null);
              }
              }}
            />
          <small className="form-text text-muted">
            <b>Filter</b> by Driver
          </small>
        </div>}
        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
          <ReactSelect
            className="basic-single"
            classNamePrefix="select"
            value={status.filter((obj) => obj.value === chargeSuccess)}
            isSearchable={true}
            name="chargeSuccess"
            options={status}
            onChange={(e) => {
              setChargeSuccess(e.value);
            }}
          />
          <small className="form-text text-muted">
            <b>Filter</b> by Status
          </small>
        </div>
        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
          <ReactSelect
            className="basic-single"
            classNamePrefix="select"
            value={payouts.filter((obj) => obj.value === fastPayout)}
            isSearchable={true}
            name="payouts"
            options={payouts}
            onChange={(e) => {
              setFastPayout(e.value);
            }}
          />
          <small className="form-text text-muted">
          <b>Filter</b> by Fast Payout
          </small>
        </div>
      </div>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination paginationProps={paginationProps} table="billsPageSize">
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                remote
                keyField="id"
                data={orders?.orders || []}
                columns={columns}
                defaultSorted={[{ dataField: "Created", order: "desc" }]}
                onTableChange={GetHandlerTableChange}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={orders?.orders || []} />
                <NoRecordsFoundMessage entities={orders?.orders || []} />
              </BootstrapTable>
                  {props?.isBills === true && orders.total ?
                   <div className="w-100 d-flex justify-content-end">
                       <div className="px-15 mx-5">
                          <h6>Total Hst: {Currency(orders?.totalHst)}</h6>
                          <h6>Total: {Currency(orders?.total)}</h6>
                       </div>
                </div> : null}
            </Pagination>
          );
        }}
      </PaginationProvider>

      <Modal
        size="xl"
        show={show}
        onHide={() => {
          setShow(false);
        }}
      >
        <Modal.Header closeButton className="border-0"></Modal.Header>
        <Modal.Body>
          <Bill
            componentRef={componentRef}
            invoices={invoices}
            isLoading={isLoading}
            name={props.name}
            showValid={true}
          />
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button
            variant="secondary"
            onClick={() => {
              setShow(false);
            }}
          >
            Close
          </Button>
          <div className="my-1 me-5">
            <button
              type="button"
              disabled={isSending}
              className="btn btn-light-info my-1 me-12"
              onClick={() => {
                SendBillByEmail();
              }
              }
            >
              {
                isSending ? 'Sending...' : 'Send Bill'
              }
            </button>
          </div>
          <div className="my-1 me-5">
            <button
              type="button"
              className="btn btn-light-primary my-1 me-12"
              onClick={handlePrint}
            >
              Print Bill
            </button>
          </div>
          <div className="my-1 me-5">
            <button
              type="button"
              disabled={downloadIsLoading}
              className="btn btn-light-success my-1 me-12"
              onClick={()=> {
                setDownloadIsLoading(true);
                downloadBillAsPDF()
              }}
            >
              {downloadIsLoading ? 'Downloading...' : 'Download PDF'}
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal
        size="xl"
        show={showShort}
        onHide={() => {
          setShowShort(false);
        }}
      >
        <Modal.Header closeButton className="border-0"></Modal.Header>
        <Modal.Body>
          <BillShort
            componentRef={componentRef}
            invoices={invoicesShort}
            isLoading={isLoading}
            name={props.name}
            startDate={startDate}
            endDate={endDate}
          />
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button
            variant="secondary"
            onClick={() => {
              setShowShort(false);
            }}
          >
            Close
          </Button>
          <div className="my-1 me-5">
            <button
              type="button"
              disabled={isSending}
              className="btn btn-light-info my-1 me-12"
              onClick={() => {
                SendBillByEmail();
              }
              }
            >
              {
                isSending ? 'Sending...' : 'Send Bill'
              }
            </button>
          </div>
          <div className="my-1 me-5">
            <button
              type="button"
              className="btn btn-light-primary my-1 me-12"
              onClick={handlePrint}
            >
              Print Bill
            </button>
          </div>
          <div className="my-1 me-5">
            <button
              type="button"
              disabled={downloadIsLoading}
              className="btn btn-light-success my-1 me-12"
              onClick={()=> {
                setDownloadIsLoading(true);
                downloadBillAsPDF()
              }}
            >
              {downloadIsLoading ? 'Downloading...' : 'Download PDF'}
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <UploadFiles show={showUpload} setShow={setShowUpload} isInvoice={false} id={invoiceId} name="Bill" />
      {showFile && <FileViewerModal show={showFile} onHide={() => {setShowFile(false)}} fileUrl={path} fromInvoice={false} />}
    </>
  );
};

export default DriverBillsTable;
